"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRectangles = exports.boundingRectsForElements = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
const uuid_1 = require("uuid");
const useWindowSize_1 = require("./useWindowSize");
const boundingRectsForElements = (elementSource) => {
    return Array.from(elementSource).map(el => el.getBoundingClientRect());
};
exports.boundingRectsForElements = boundingRectsForElements;
// Any element on the page which has a css class of cssClassName will have its container rectangles tracked.
const useRectangles = () => {
    const containerRef = (0, react_1.useRef)(null);
    const windowSize = (0, useWindowSize_1.useWindowSize)();
    const cssClassName = (0, react_1.useMemo)(() => (0, uuid_1.v1)(), []);
    const previousRectangles = (0, react_1.useRef)([]);
    const [rectangles, setRectangles] = (0, react_1.useState)([]);
    // calculate currentRectangles.
    const containerScrollTop = containerRef.current?.scrollTop || 0;
    const containerRectangleTop = containerRef.current?.getBoundingClientRect()?.top ?? 0;
    const elements = document.getElementsByClassName(cssClassName);
    const currentRectangles = (0, exports.boundingRectsForElements)(elements).map(rectangle => {
        return {
            containerTop: containerRectangleTop,
            midpointFromContainerTop: rectangle.top - containerRectangleTop + 0.5 * rectangle.height,
            height: rectangle.height,
            width: rectangle.width,
            left: rectangle.left,
            right: rectangle.right,
            top: rectangle.top,
            bottom: rectangle.bottom,
        };
    });
    (0, react_1.useEffect)(() => {
        if (!(0, lodash_1.isEqual)(previousRectangles.current, currentRectangles)) {
            previousRectangles.current = [...currentRectangles];
            setRectangles(currentRectangles);
        }
    }, [currentRectangles, containerRef, windowSize.width, windowSize.height, containerScrollTop]);
    return {
        rectangles,
        containerRef,
        cssClassName,
    };
};
exports.useRectangles = useRectangles;
